module.exports = __webpack_public_path__ + "static/media/mic-check-2.26f85200.png";